import Vue from 'vue'

import * as VueGoogleMaps from '@/node_modules/vue2-google-maps'

import GmapCluster from "vue2-google-maps/dist/components/cluster"

Vue.component('GmapCluster', GmapCluster)

// Only initialize Google Maps if API key is provided
if (process.env.GOOGLE_MAPS_KEY) {
  Vue.use(VueGoogleMaps, {
    load: { key: process.env.GOOGLE_MAPS_KEY }
  })
} else {
  console.warn('[Google Maps] GOOGLE_MAPS_KEY not set - Google Maps disabled')
}
